var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "border-r py-2 ml-11 item-holder relative",
      staticStyle: { width: "12.2128rem", height: "80px" },
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-row items-center content-center mt-4" },
        [
          _c(
            "Tooltip",
            {
              attrs: {
                title: _vm.item.title,
                variant: _vm.TooltipVariants.DARK,
                placement: "top",
              },
            },
            [
              _c("div", { staticClass: "text ml-10 truncate w-36" }, [
                _vm._v(_vm._s(_vm.item.title) + " "),
              ]),
            ]
          ),
        ],
        1
      ),
      _c("div", {
        staticClass:
          "absolute -mt-19 border-b border-l border-primary h-16 w-4 rounded-bl-md",
      }),
      _c("div", {
        staticClass:
          "absolute -mt-4 ml-4 border border-primary h-1.5 w-1.5 rounded-full bg-primary",
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }